import * as v from 'valibot';
import { integerInRange, dateStringSchema } from '../util/valibot';
export const nexaReceiverKindSchema = v.union([v.literal('onoff'), v.literal('dimmer')]);
export const nexaReceiverCodeSchema = v.object({
    code: integerInRange(0, 0x3ffffff),
    unit: integerInRange(0, 15),
});
export const nexaReceiverSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    kind: nexaReceiverKindSchema,
    title: v.string(),
    codes: v.array(nexaReceiverCodeSchema),
    comment: v.string(),
    created: dateStringSchema,
});
export function nexaReceiverKindLabel(kind) {
    switch (kind) {
        case 'onoff': return 'På/Av';
        case 'dimmer': return 'Dimmer';
    }
}
